

import Group from './group.vue';

export default {

    components: {
        Group
    },

    created() {
        let t = this;
        t.loadData();
    },

    activated() {
        let t = this;
    },

    methods: {

        groupChange() {
            let t = this;
            t.loadData();
            t.$forceUpdate();
        },

        syncUnread(options) {
            let t = this;

            if (options.user_unread) {
                let ids = Object.keys(options.user_unread);
                for (let i = 0; i < ids.length; i++) {
                    const employeeId = ids[i];
                    if (t.dict.employee[employeeId]) {
                        t.dict.employee[employeeId].count = options.user_unread[employeeId];
                    }
                    else {
                        t.loadData();
                        return;
                    }
                }
            }

            if (options.group_unread) {
                let ids = Object.keys(options.group_unread);
                for (let i = 0; i < ids.length; i++) {
                    const groupId = ids[i];
                    if (t.dict.group[groupId]) {
                        t.dict.group[groupId].count = options.group_unread[groupId];
                    }
                    else {
                        t.loadData();
                        return;
                    }
                }
            }
        },

        loadData() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            t.list.employee.clear();
            t.list.group.clear();

            let p = {};

            axios.get('im/getContacts', { params: p }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    let unread = 0;

                    let employees = res.data.options.employees;
                    let groups = res.data.options.groups;


                    employees.forEach(item => {
                        if (item.count && item.count > 0) {
                            unread++;
                        }
                        t.list.employee.push(item);
                    });


                    groups.forEach(item => {
                        item.showGroupMenu = false;
                        item.isSupport = false;
                        if (item.support_ids) {
                            let ids = item.support_ids.split(',');
                            if (ids.indexOf(t.U.id.toString()) >= 0) {
                                item.isSupport = true;
                            }
                        }
                        if (item.count && item.count > 0) {
                            unread++;
                        }
                        t.list.group.push(item);
                    });

                    t.dict.employee = listToDict(employees);
                    t.dict.group = listToDict(groups);

                    t.$eventBus.$emit('refresh-unread', false, unread);
                }
            });

        },

        goGroup(item) {
            this.$emit('go-group', item);
        },

        goEmployee(item) {
            this.$emit('go-employee', item);
        },

        addGroup() {
            let t = this;
            t.groupId = null;
            t.showGroupEditor = true;
        },

        groupConfig(item) {
            let t = this;
            t.groupId = item.id;
            t.showGroupEditor = true;
        },

        removeGroup(item) {

            let t = this;

            axios.delete('chatGroup/' + item.id).then(res => {
                if (res.data.status == 1) {
                    A.toast('グループの解散が完了しました。');
                    t.list.group.remove(item);
                }
            });

        },

        exitGroup(item) {
            let t = this;

            axios.post('chatGroup/exit/' + item.id).then(res => {
                if (res.data.status == 1) {
                    A.toast('グループの退出に成功しました。');
                    t.list.group.remove(item);
                }
            });

        },
    },

    data() {
        return {
            groupId: 0,
            groupConfigMode: '',
            showGroupEditor: false,
            view: 'contact',
            tab: 'unread',
            search: {
                keywords: ''
            },
            dict: {
                group: {},
                employee: {}
            },
            list: {
                employee: [],
                group: [],
            },
        };
    },

    computed: {
        employee() {
            let t = this;
            let arr = [];

            t.list.employee.forEach(item => {

                if (t.search.keywords) {
                    if (item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
                else {
                    arr.push(item);
                }
            });

            return arr;
        },
        employee_unreadMsg() {

            let t = this;
            let arr = [];

            t.list.employee.forEach(item => {

                if (!item.count) {
                    return;
                }

                if (t.search.keywords) {
                    if (item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
                else {
                    arr.push(item);
                }
            });


            return arr;
        },
        group() {
            let t = this;
            let arr = [];

            t.list.group.forEach(item => {

                if (t.search.keywords) {
                    if (item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
                else {
                    arr.push(item);
                }
            });

            return arr;
        },
        group_unreadMsg() {

            let t = this;
            let arr = [];

            t.list.group.forEach(item => {

                if (!item.count) {
                    return;
                }

                if (t.search.keywords) {
                    if (item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
                else {
                    arr.push(item);
                }
            });

            return arr;
        },
    }
};
